<template>
  <div   >
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-card style="margin-top: 250px">
      <br/>
      <h1 align="center" style="text-decoration: underline overline">
        Daftar HID
      </h1>

      <!-- pilih pusingan -->
    
      <v-card-title> Daftar HID </v-card-title>
      <v-container>

        <v-row>
          <v-col cols="3">
            <v-select
              :items="Pusngn"
              :item-text="item => item.pusingan +' - '+ item.tahun"
              label="Ps"
              return-object
              outlined
              dense
              @change="onChange($event)"
              v-model="PUSINGAN"
            ></v-select>
          </v-col>

          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="BULAN"
              label="BULAN"
              required
              disabled
            ></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="TAHUN"
              label="TAHUN"
              required
              disabled
            ></v-text-field>
          </v-col>

          <v-col cols="1">
            <v-text-field
              outlined
              dense
              v-model="KAW"
              label="KAW"
              required
              disabled
            ></v-text-field>
          </v-col>
        </v-row>


        <!-- DATATABLE  -->
        <v-card color="rgba(217, 217, 217, 0.5)">
          <v-card-title>
            Senarai Batch
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="dataBatch"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
          ></v-data-table>
        </v-card>
      </v-container>

    <!-- POPUP bila click data row -->
    <v-dialog v-model="rowClick" max-width="1000">
      <v-card>
        <v-card-title class="text-h5"> Pilihan Batch </v-card-title>

        <v-card-text>
          <!-- info  -->
          <v-row>
            <v-col>
              No. Batch
              <v-text-field
                outlined
                dense
                v-model="rowClickArray.BNO"
                disabled
              ></v-text-field>
            </v-col>
            <v-col>
              Jumlah Borang
              <v-text-field
                outlined
                dense
                v-model="rowClickArray.JumBorang"
                required
                disabled
              ></v-text-field>
            </v-col>
            <v-col>
              Borang Selesai
              <v-text-field
                outlined
                dense
                v-model="BorangSelesai"
                disabled
              ></v-text-field>
            </v-col>

            <v-col>
              Penyelia Operasi
              <v-text-field
                outlined
                dense
                v-model="rowClickArray.namaPOperasi"
                disabled
              ></v-text-field>
            </v-col>
            <v-col>
              Penyelia Prosesan
              <v-text-field
                outlined
                dense
                v-model="rowClickArray.namaPProsesan"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- DATATABLE Senarai Borang  -->
          <v-row class="justify-center">
            <v-card>
              <v-card-title>
                Senarai Borang
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers2"
                :items="dataBorang"
                :search="search2"
                class="ml-3 mr-3"
                @click:row="handleClick2"
                :footer-props="{ 'items-per-page-options': [2, 5, -1] }"
              ></v-data-table>
            </v-card>
          </v-row>
        </v-card-text>

        <!-- Form daftar HID -->
        <h1 align="center" style="text-decoration: underline overline">
          Daftar HID
        </h1>
        <v-card class="ml-2 mr-2">
          <v-card-title> Butir-Butir Pengenalan </v-card-title>
          <v-card-text>
            <v-form ref="daftarHIDform" v-model="valid" lazy-validation>
              <!-- BNO,Ps,S,Negeri -->
              <v-row>
                <v-col cols="12" sm="2">
                  S
                  <v-select
                    :items="selectionS"
                    :item-text="item => item.id +' - '+ item.desc"
                    label="Sila pilih"
                    return-object
                    outlined
                    v-model="S"
                    :disabled="disabledS"
                  ></v-select>
                </v-col>
              </v-row>
<div v-show="showBorangPengisianHID">
              <!-- DP,DB,BP,ST,NOTK,NOIR,R -->
              <v-row>
                <v-col cols="12" sm="3">
                  DP
                  <v-text-field
                    outlined
                    dense
                    v-model="DP"
                    :error-messages="dpErrors"
                    :success-messages="dpSuccess"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                  DB
                  <v-text-field
                    outlined
                    dense
                    v-model="DB"
                    :error-messages="dbErrors"
                    :success-messages="dbSuccess"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                  BP
                  <v-text-field
                    outlined
                    dense
                    v-model="BP"
                    :error-messages="bpErrors"
                    :success-messages="bpSuccess"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                  ST
                  <v-text-field
                    outlined
                    dense
                    v-model="ST"
                    :error-messages="stErrors"
                    :success-messages="stSuccess"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4">
                  NOTK
                  <v-text-field
                    outlined
                    dense
                    v-model="NOTK"
                    :rules="[rules.required, rules.NOTKlength]"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  NOIR
                  <v-text-field
                    outlined
                    dense
                    v-model="NOIR"
                    :rules="[rules.required, rules.NOIRlength]"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  R
                  <v-select
                      :items="lookupRespon"
                      :item-text="item => item.id +' - '+ item.desc"
                      return-object
                      solo
                      dense
                      v-model="R"
                      
                  ></v-select>
                </v-col>
              </v-row>

              <!-- nama,noic -->
              <v-row>
                <v-col>
                  Nama
                  <v-text-field outlined dense v-model="Nama"></v-text-field>
                </v-col>
              </v-row>

              <!-- alamat -->
              <v-row>
                <v-col>
                  Alamat
                  <v-text-field outlined dense v-model="Alamat"></v-text-field>

                  <v-text-field outlined dense v-model="Alamat1"></v-text-field>

                  <v-text-field outlined dense v-model="Alamat2"></v-text-field>

                  <v-text-field outlined dense v-model="Alamat3"></v-text-field>
                </v-col>
              </v-row>

              <!-- poskod,notel,emel -->
              <v-row>
                <v-col cols="4">
                  Poskod
                    <v-autocomplete
                      :items="lookupposkod"
                      item-text="Poskod"
                      return-object
                      outlined
                      dense
                      v-model="Poskod"
                    ></v-autocomplete>
                </v-col>

                <v-col cols="4">
                  No. Tel
                  <v-text-field
                    outlined
                    dense
                    v-model="Notelefon"
                    type="number"
                    :min="0"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- tk ulangan, sample -->
              <v-row>
                <v-col cols="4">
                  TK Ulangan
                  <v-select
                      :items="yaTidak"
                      item-text="desc"
                      return-object
                      solo
                      dense
                      v-model="TK_ulangan"
                  ></v-select>
                </v-col>
                <v-col cols="4">
                 Sampel TK Panel
                  <v-select
                      :items="selectionS"
                      :item-text="item => item.id +' - '+ item.desc"
                      return-object
                      solo
                      dense
                      v-model="Sample"
                      v-show="showSample"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Jumlah Isi Rumah -->
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    dense
                    v-model="JIR"
                    type="number"
                    label="Jumlah Isi Rumah"
                    :min="0"
                  ></v-text-field>
                </v-col>

                <v-col cols="1">
                  <v-icon  x-large>mdi-slash-forward</v-icon>
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    outlined
                    dense
                    v-model="TOTJIR"
                    type="number"
                    label="Jumlah Keseluruhan Isi Rumah"
                    :min="0"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Responden/Pembanci -->
              <v-row>
                <v-col>
                  Responden/Pembanci
                  <v-radio-group
                    v-model="pengisian"
                    row
                    :rules="rules.required"
                  >
                    <v-radio label="Responden" :value=1 v-show="buttonResponden"></v-radio>
                    <v-radio label="Pembanci" :value=2></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row>
                <!-- button simpan -->
                <v-col>
                  <v-btn color="success" @click="simpanHID()" v-show="butangSimpan"> SIMPAN </v-btn>

                  <v-btn class="ml-2" color="warning" @click="updateHID()" v-show="butangKemaskini"> KEMASKINI </v-btn>

                  <v-btn class="ml-2" color="error" @click="rowClick = false">
                    {{ $t("batal") }}
                  </v-btn>
                </v-col>
              </v-row>
</div>

            </v-form>
          </v-card-text>
        </v-card>
      </v-card>
      <!-- Form daftar HID -->
    </v-dialog>

    <!-- Pilih hies atau his -->
    <v-dialog v-model="goToBorang" max-width="800" min-height="auto">
      <v-card>
        <v-card-actions class="justify-center">
          
          <v-btn color="warning" @click="openHIS()"> PROSESAN HIS </v-btn>

          <v-btn color="primary" @click="openHES()" v-if="hiesOption == '1'">
            PROSESAN HES
          </v-btn>
          <!-- maitambah -->
          <!-- <v-btn color="primary" @click="openHEStest()" v-if="hiesOption == '1'">
            PROSESAN HES test
          </v-btn> -->

          <v-spacer></v-spacer>
              <v-btn color="primary" text @click="goToBorang = false">
                {{ $t("tutup") }}
              </v-btn>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="readyUpdateDataHID()"> KEMASKINI </v-btn>
          <v-btn color="error" @click="dialogPengesahan=true;">{{ $t("padam") }}</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalkemaskinipppo" persistent width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("tetapkanpppo") }}
        </v-card-title>
        <v-container>
          <Pppoinput></Pppoinput>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="paparhiesidhid" persistent max-width="400">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  outlined
                  dense
                  v-model="paparhidbaru"
                  v-bind:label="$t('hid')"
                  :disabled="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  outlined
                  dense
                  v-model="paparnotac"
                  label="Tac"
                  :disabled="true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4 white--text" @click="tutupmodalhiesid">
            {{ $t("tutup") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIalog Pengesahan -->
    <v-row justify="center">
      <v-dialog
        v-model="dialogPengesahan"
        persistent
        max-width="550"
        max-height="auto"
      >
        <v-card>
          <v-card-text>
          {{$t("Adakah anda pasti untuk padam?")}}<br><br>
          <strong>{{$t(" HID: "+paparHID)}}</strong>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              @click="dialogPengesahan = false;"
            >
            {{$t('batal')}}
            </v-btn>

            <v-btn
              color="error"
              @click="dialogPengesahanDuplicate = true"
            >
              {{$t('padam duplicate')}}
            </v-btn>

            <v-btn
              color="error"
              @click="dialogPengesahanDeleteHID = true"
              v-if="role != 'FE'"
            >
              {{$t('padam HID')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Pengesahan Padam Dialog -->
  <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahanDuplicate"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{"Adakah Anda Pasti Untuk Memadam Duplicate?"}}</strong><br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahanDuplicate = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamDuplicateHID()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahanDeleteHID"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{"Adakah Anda Pasti Untuk Memadam HID beserta data-datanya?"}}</strong><br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahanDeleteHID = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamHID()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
//////////////services//////////////////
import getPusingan from "@/services/pusingan";
const paparpusingan = new getPusingan();

import daftarHID from "@/services/daftarHID";
const hidServices = new daftarHID();

import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();

import Pppoinput from "@/components/Pppoinput/pppoinput";
export default {
  components: {
    Pppoinput,
  },
  async beforeMount() {
    this.userData = localStorageData.user();
    this.namaPOperasi = this.userData.name;
    this.KODNEG = this.userData.kodneg;
    this.role = this.userData.role;
    this.yaTidak = lookupFieldServices.getYaTidak();
    this.lookupposkod = await lookupFieldServices.getPoskod(this.KODNEG);
    this.lookupRespon = lookupFieldServices.getRespons();
    this.R = this.lookupRespon[10];
    this.getPusinganData();
  },
  setup() {},
  mounted() {
    this.modalkemaskinipppo = localStorageData.checkpppo() === 0 ? false : true;
  },
  data: () => ({

    toBeUpdatedHID:'',
    butangSimpan : true,
    butangKemaskini: false,

    disabledR: true,
    disabledS: false,

    dialogPengesahan: false,
    dialogPengesahanDuplicate: false,
    dialogPengesahanDeleteHID: false,

    showBorangPengisianHID:false,

    modalkemaskinipppo: false,
    paparhidbaru: "",
    paparnotac: "",
    paparhiesidhid: false,
    snackbar: "",
    paparHID: "",
    userData: "",
    errorDialog: "",
    errMessage: "",
    dpErrors: [],
    dpSuccess: [],
    dbErrors: [],
    dbSuccess: [],
    bpErrors: [],
    bpSuccess: [],
    stErrors: [],
    stSuccess: [],
    yaTidak:[],
    //selectionS: [{"id":"1","desc":"HIES"},{"id":"2","desc":"HIS"}],
    selectionS: [{"id":"1","desc":"HIES"}],
    successMessage: "",
    successDialog: false,
    buttonResponden: true,
    search: "",
    search2: "",
    role: "",
    rowClick: false,
    goToBorang: false,
    rowClickArray: [],
    rowClickArray2: [],
    showSample: true,
    hiesOption: "",
    kodCaw: "",
    KAW: "",
    BULAN: "",
    TAHUN: "",
    KODNEG: "",
    PUSINGAN: "",
    BNO: "",
    JumBorang: "",
    PP: "",
    P: "",
    namaPProsesan: "",
    PO: "",
    namaPOperasi: "",
    penciptaID: "",
    dataBatch: [],
    dataBorang: [],
    Pusngn: [],
    lookupposkod:[],
    lookupRespon: [],
    datahandleClick2: [],
    Nama: "",
    NOIC: "",
    Alamat: "",
    Alamat1: "",
    Alamat2: "",
    Alamat3: "",
    Poskod: "",
    Notelefon: "",
    Email: "",
    JIR: "",
    TOTJIR: "",
    Sample: "",
    S: "",
    NG: "",
    NEGERI: "",
    DP: "",
    DB: "",
    BP: "",
    BP6digit:"",
    ST: "",
    NOTK: "",
    NOIR: "",
    R: "",
    pengisian: '',
    TK_ulangan: "",
    statusHID:"",

    headers: [
      { text: "BatchID", value: "batchID", align: " d-none" },
      {
        text: "No. Batch",
        align: "start",
        value: "BNO",
        width: 12,
      },
      { text: "Jumlah Borang", value: "JumBorang", width: 12, sortable: false },
      { text: "Penyelia Operasi", value: "namaPOperasi", sortable: false },
      { text: "Penyelia Prosesan", value: "namaPProsesan", sortable: false },
      //,align: ' d-none'
    ],
    headers2: [
      { text: "HIDID", value: "HIDID", align: " d-none" },
      {
        text: "BNO",
        align: "start",
        value: "BNO",
        width: 12,
      },
      { text: "P", value: "P", width: 12 },
      { text: "S", value: "S", width: 12 },
      { text: "DP", value: "DP", width: 12 },
      { text: "DB", value: "DB", width: 12 },
      { text: "BP", value: "BP", width: 12 },
      { text: "ST", value: "ST", width: 12 },
      { text: "NOTK", value: "NOTK", width: 12 },
      { text: "NOIR", value: "NOIR", width: 12 },
      { text: "R", value: "R", width: 12 },
      { text: "TK Ulangan", value: "TK_ulangan", width: 12 },
      { text: "JIR", value: "JIR", width: 12 },
      { text: "TOTJIR", value: "TOTJIR", width: 12 },
      { text: "Status", value: "statusHID", width: 12 },
      //,align: ' d-none'
    ],
    valid: false,
    name: "",
    rules: {
      required: (v) => !!v || "field is required",
      Slength: (value) => {
        return (value && value.length == 1) || "must be 1 digit";
      },
      NOTKlength: (value) => {
        return (value && value.length == 4) || "must be 4 digit";
      },
      NOIRlength: (value) => {
        return (value && value.length == 2) || "must be 2 digit";
      },
      Rlength: (value) => {
        return (value && value.length == 1) || "must be 1 digit";
      },
      poskodLength: (value) => {
        return (value && value.length == 5) || "must be 5 digit";
      },
      notkLength: (value) => {
        return (value && value.length == 1) || "must be 1 digit";
      },
      emel: (value) => {
        return /.+@.+\..+/.test(value) || "E-mail must be valid";
      },
    },
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    checkbox: false,
  }),

  methods: {
    async tutupmodalhiesid() {
      window.location.reload();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.daftarHIDForm.reset();
      this.$refs.daftarHIDForm.resetValidation() 
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    handleClick(row) {
      this.getSenaraiBorangByBNO(row.BNO);
      
      //bukak modal daftar hid//
      this.rowClick = true;
      this.butangSimpan = true;
      
      //initialize data row yg diclick kepada modal
      this.rowClickArray = row;
    },
    handleClick2(row) {
      //console.log(row);
      this.paparHID = row.HID;
      this.hiesOption = row.S;
      this.rowClickArray2 = row;
      this.goToBorang = true;
      this.statusHID = row.statusHID;
    },
    onChange() {
      this.BULAN = this.PUSINGAN.bulan;
      this.TAHUN = this.PUSINGAN.tahun;
      ///dapatkan list batch yang didaftar bedasarkan PUSINGAN
      this.getBatchData(this.PUSINGAN.pusingan);
    },
    async getBatchData(ps) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/HID/getBatchPS?KODNEG=`+this.KODNEG+`&PUSINGAN=`+ps+`&TAHUN=`+this.TAHUN,
          {}
        );
        var dataz = res.data.data;
        this.dataBatch = dataz;
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },
    async getPusinganData() {
      var res = await paparpusingan.getPusinganData();
      //this.Pusngn = res.data.data;
      var listPusinganAll = res.data.data;
      this.Pusngn = listPusinganAll.filter(obj => obj[this.KODNEG] === 1);
    },
    async getSenaraiBorangByBNO(rowBNO) {
      try {
         const senaraibno = {
            BNO: rowBNO,
            bulan: this.PUSINGAN.bulan,
            pusingan: this.PUSINGAN.pusingan,
            tahun: this.PUSINGAN.tahun,
            negeri: this.KODNEG
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/HID/senaraiBorang`, senaraibno
        );
        //var dataz = res.data.data
        this.dataBorang = res.data.data;
      } catch (error) {
        console.log("senaraiBorang" + error);
      }
    },
    simpanHID() {
      this.butangSimpan = false;
      if (
        this.$refs.daftarHIDform.validate() &&
        this.dpErrors.length <= 0 &&
        this.dbErrors <= 0 &&
        this.bpErrors <= 0 &&
        this.stErrors <= 0
      ){

          var checkJIR = this.JIR.toString().length;
          var checkTOTJIR = this.TOTJIR.toString().length;
          if(checkJIR < 2){
            this.JIR = "0"+this.JIR;
          }
          if(checkTOTJIR < 2){
            this.TOTJIR = "0"+this.TOTJIR;
          }

        //checking semua form ok
        //pangill service HID
        hidServices
          .simpanHID({
            BULAN: this.BULAN,
            TAHUN: this.TAHUN,
            KAW: this.KAW,
            NG: this.KODNEG,
            NEGERI: this.NEGERI,
            BNO: this.rowClickArray.BNO,
            //NOIC : this.NOIC,
            Nama: this.Nama,
            Alamat: this.Alamat,
            Alamat1: this.Alamat1,
            Alamat2: this.Alamat2,
            Alamat3: this.Alamat3,
            Poskod: this.Poskod.Poskod,
            Notelefon: this.Notelefon,
            //Email: this.Email,
            TK_ulangan: this.TK_ulangan.id,
            Sample: this.Sample.id,
            P: this.PUSINGAN.pusingan,
            S: this.S.id,
            DP: this.DP,
            DB: this.DB,
            BP: this.BP6digit,
            ST: this.ST,
            NOTK: this.NOTK,
            NOIR: this.NOIR,
            R: this.R.id,
            JIR: this.JIR,
            TOTJIR: this.TOTJIR,
            namaPOperasi: this.namaPOperasi,
            namaPProsesan: this.namaPProsesan,
            pengisian: this.pengisian,
            HID:
              this.rowClickArray.BNO +
              this.PUSINGAN.pusingan +
              this.S.id +
              this.rowClickArray.KODNEG +
              this.DP +
              this.DB +
              this.BP6digit +
              this.ST +
              this.NOTK +
              this.NOIR,
          })
          .then((data) => {
            if (data.data.status) {
              this.rowClick = false;
              this.$refs.daftarHIDform.reset();
              this.paparhidbaru = data.data.hid;
              this.paparnotac = data.data.notac;
              this.paparhiesidhid = true;
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
            } else {
              this.snackbar = {
                message: `${data.data.message}`,
                timeout: 3000,
                color: "red darken-4",
                show: true,
              };
            }
          });
      }
    },
    updateHID() {
      if (
        this.$refs.daftarHIDform.validate() &&
        this.dpErrors.length <= 0 &&
        this.dbErrors <= 0 &&
        this.bpErrors <= 0 &&
        this.stErrors <= 0
      ) {

          var checkJIR = this.JIR.toString().length;
          var checkTOTJIR = this.TOTJIR.toString().length;
          if(checkJIR < 2){
            this.JIR = "0"+this.JIR;
          }
          if(checkTOTJIR < 2){
            this.TOTJIR = "0"+this.TOTJIR;
          }

        //checking semua form ok
        //pangill service HID
        hidServices
          .updateHID({
            BULAN: this.BULAN,
            TAHUN: this.TAHUN,
            KAW: this.KAW,
            NG: this.KODNEG,
            NEGERI: this.NEGERI,
            BNO: this.rowClickArray.BNO,
            //NOIC : this.NOIC,
            Nama: this.Nama,
            Alamat: this.Alamat,
            Alamat1: this.Alamat1,
            Alamat2: this.Alamat2,
            Alamat3: this.Alamat3,
            Poskod: this.Poskod.Poskod,
            Notelefon: this.Notelefon,
            //Email: this.Email,
            TK_ulangan: this.TK_ulangan.id,
            Sample: this.Sample.id,
            P: this.PUSINGAN.pusingan,
            S: this.S.id,
            DP: this.DP,
            DB: this.DB,
            BP: this.BP6digit,
            ST: this.ST,
            NOTK: this.NOTK,
            NOIR: this.NOIR,
            R: this.R.id,
            JIR: this.JIR,
            TOTJIR: this.TOTJIR,
            namaPOperasi: this.namaPOperasi,
            namaPProsesan: this.namaPProsesan,
            pengisian: this.pengisian,
            HID:
              this.rowClickArray.BNO +
              this.PUSINGAN.pusingan +
              this.S.id +
              this.rowClickArray.KODNEG +
              this.DP +
              this.DB +
              this.BP6digit +
              this.ST +
              this.NOTK +
              this.NOIR,
            toBeUpdatedHID: this.toBeUpdatedHID
          })
          .then((data) => {
            if (data.data.status) {
              this.rowClick = false;
              this.$refs.daftarHIDform.reset();

              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
            } else {
              this.snackbar = {
                message: `${data.data.message}`,
                timeout: 3000,
                color: "red darken-4",
                show: true,
              };
            }
          });
      }
    },
    async padamHID(){

      try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/deleteHID`, {HID:this.paparHID});

        if(res.data.status == true){
          this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
              this.getSenaraiBorangByBNO(this.rowClickArray);
              this.dialogPengesahan = false;
              this.dialogPengesahanDeleteHID = false;
              this.goToBorang = false;
        }else{
              this.snackbar = {
                message: `error`,
                timeout: 3000,
                color: "red darken-4",
                show: true,
              };
        }

      } catch (error) {
         console.log("deleteHID: " + error);
      }
    },
    async padamDuplicateHID(){
      try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/deleteDuplicateHID`, {HIDID:this.rowClickArray2.HIDID});

        if(res.data.status == true){
          this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
              //this.getSenaraiBorangByBNO(this.rowClickArray);
              this.dialogPengesahan = false;
              this.dialogPengesahanDuplicate = false;
              this.goToBorang = false;
              this.rowClick = false;
              
        }else{
              this.snackbar = {
                message: `error`,
                timeout: 3000,
                color: "red darken-4",
                show: true,
              };
        }

      } catch (error) {
         console.log("delete Duplicate HID: " + error);
      }

    },
    readyUpdateDataHID(){
      this.goToBorang = false;
      this.butangSimpan = false;
      this.butangKemaskini = true;
      this.disabledR = false;
      this.disabledS = true;
      this.toBeUpdatedHID = this.rowClickArray2.HID;

      if(this.rowClickArray2.S == 1){
        this.S = this.selectionS[0];
      }
      if(this.rowClickArray2.S == 2){
        this.S = this.selectionS[1];
      }
      this.DP = this.rowClickArray2.DP;
      this.DB = this.rowClickArray2.DB;
      this.BP = this.rowClickArray2.BP;
      this.ST = this.rowClickArray2.ST;
      this.NOTK = this.rowClickArray2.NOTK;
      this.NOIR = this.rowClickArray2.NOIR;
      if(this.rowClickArray2.R == "99"){
        this.R = this.lookupRespon[10];
      }else{
        this.R = this.lookupRespon[this.rowClickArray2.R];
      }
      
      this.Nama = this.rowClickArray2.Nama;
      this.Alamat = this.rowClickArray2.Alamat;
      this.Alamat1 = this.rowClickArray2.Alamat1;
      this.Alamat2 = this.rowClickArray2.Alamat2;
      this.Alamat3 = this.rowClickArray2.Alamat3;
      this.Poskod = this.rowClickArray2.Poskod;
      this.Notelefon = this.rowClickArray2.Notelefon;
      this.JIR = this.rowClickArray2.JIR;
      this.TOTJIR = this.rowClickArray2.TOTJIR;
      this.pengisian = this.rowClickArray2.pengisian;
     
      if(this.rowClickArray2.TK_ulangan == 1){
        this.TK_ulangan = this.yaTidak[0];
        if(this.rowClickArray2.Sample == 1){
          this.Sample = this.selectionS[0];
        }
        if(this.rowClickArray2.Sample == 2){
          this.Sample = this.selectionS[1];
        }
      }
      if(this.rowClickArray2.TK_ulangan == 2){
        this.TK_ulangan = this.yaTidak[1];
      }

    },
    openHIS() {
      this.goToBorang = false;
      var setHIDtoLocalStorage = localStorageData.setHID(this.rowClickArray2);
      this.$router.push({ name: "ringkasanMaklumatIR" });
    },
    openHES() {
      this.goToBorang = false;
      axios
        .get(`${process.env.VUE_APP_API_URL}/auth/encode?en=${this.paparHID}`)
        .then((result) => {
          this.$router.push(
            `/${i18n.locale}/BLK3PreCode/${result.data.encode}`,
            () => {}
          );
        });
    },
    //maitambah
    openHEStest() {
      this.goToBorang = false;
      axios
        .get(`${process.env.VUE_APP_API_URL}/auth/encode?en=${this.paparHID}`)
        .then((result) => {
          this.$router.push(
            `/${i18n.locale}/BLK3PreCodeTest/${result.data.encode}`,
            () => {}
          );
        });
    },
  },
  watch: {
    async DP(val) {
      this.dpErrors = ["Checking.."];
      if (val == "") {
        this.dpErrors = ["RALAT"];
        this.dpSuccess = [];
      } else {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/HID/checkDP?DP=` + val +`&negeri=`+this.KODNEG
        );

        if (val !== this.DP) return;
        if (res.data.status == "SUCCESS") {
          this.dpErrors = [];
          this.dpSuccess = ["SAH"];
        } else {
          this.dpErrors = ["RALAT"];
          this.dpSuccess = [];
        }
      }
    },
    async DB(val) {
      this.dbErrors = ["Checking.."];
      if (val == "") {
        this.dbErrors = ["RALAT"];
        this.dbSuccess = [];
      } else {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/HID/checkDB?db=` + val +`&negeri=`+this.KODNEG
        );

        if (val !== this.DB) return;
        if (res.data.status == "SUCCESS") {
          this.dbErrors = [];
          this.dbSuccess = ["SAH"];
        } else {
          this.dbErrors = ["RALAT"];
          this.dbSuccess = [];
        }
      }
    },
    async BP(val) {
      this.bpErrors = ["Checking.."];
      if (val == "" || val.length != 6) {
        this.bpErrors = ["RALAT"];
        this.bpSuccess = [];
      } else {
        var noBP = val;
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/HID/checkBP?bp=` + noBP +`&negeri=`+this.KODNEG
        );

        if (val !== this.BP) return;
        if (res.data.status == "SUCCESS") {
          this.BP6digit = noBP;
          this.bpErrors = [];
          this.bpSuccess = ["SAH"];
        } else {
          this.bpErrors = ["RALAT"];
          this.bpSuccess = [];
        }
      }
    },
    async ST(val) {
      this.stErrors = ["Checking.."];
      if (val == "") {
        this.stErrors = ["RALAT"];
        this.stSuccess = [];
      } else {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/HID/checkST?st=` + val +`&negeri=`+this.KODNEG
        );

        if (val !== this.ST) return;
        if (res.data.status == "SUCCESS") {
          this.stErrors = [];
          this.stSuccess = ["SAH"];
        } else {
          this.stErrors = ["RALAT"];
          this.stSuccess = [];
        }
      }
    },
    S(val){

      this.showBorangPengisianHID = false;
      if(val.id == 1){
        this.buttonResponden = false;
        this.showBorangPengisianHID = true;
      }
      if(val.id == 2){
        this.buttonResponden = true;
        this.showBorangPengisianHID = true;
      }
    },
    TK_ulangan(val){
      if(val.id == 1){
        this.showSample = true;
      }
      if(val.id == 2){
        this.showSample = false;
        this.Sample = {"id":0}
      }
    }
  },
  computed:{
    BorangSelesai(){
      var total = 0;
      for(var i = 0; i< this.dataBorang.length; i++ ){
        console.log(this.dataBorang[i].statusHID)
        if(this.dataBorang[i].statusHID == 3 || this.dataBorang[i].statusHID == 4){
          total = total + 1;
        }
      }
      console.log(total)
      return total;
    }
  }
};
</script>

<style>
</style>

<style scoped>
.v-text-field .poskod {
  width: 400px;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

</style>

